import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  API_INITIATE_GET_AMC_CUSTOMER_DATA,
  API_COMPLETE_GET_AMC_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_AMC_CUSTOMER_DATA,
  API_INITIATE_POST_AMC_OPTIMIZE_PLAN_DATA,
  API_COMPLETE_POST_AMC_OPTIMIZE_PLAN_DATA,
  API_INITIATE_SUBMIT_AMC_CUSTOMER_DATA,
} from '../../app-constants';
import View from './amc-homepage.presenter';
import { submitAMCCustomerData, submitAMCOptimizePlanData, submitAMCRequestCallback, downloadCustomerProposal } from './amc-homepage.actions';
// Reducer
export const amcHomePageReducer = (state = {
  loading: false,
  dataLoaded: false,
  formSubmitted: false,
  customerAccountName: '',
  customerAccountNumber: '',
  customerAbn: '',
  getData: '',
  referenceNumber: '',
  alreadySubmitted: false,
  optimizeInProgress: false,
  submissionInProgress: false,
  loadedOptimizeData: false,
  optimizePlanData: '',
  alreadySubmittedDate: '',
}, action) => {
  switch (action.type) {
    case API_INITIATE_GET_AMC_CUSTOMER_DATA:
      return { ...state, loading: true, dataLoaded: false, formSubmitted: false };
    case API_INITIATE_SUBMIT_AMC_CUSTOMER_DATA:
      return { ...state, formSubmitted: false, submissionInProgress: true };
    case API_COMPLETE_SUBMIT_AMC_CUSTOMER_DATA:
      return { ...state, loading: false, formSubmitted: true, submissionInProgress: false };
    case API_COMPLETE_GET_AMC_CUSTOMER_DATA: {
      return {
        ...state,
        loading: false,
        dataLoaded: true,
        customerAccountName: action.data.accountName,
        customerAccountNumber: action.data.accountNumber,
        customerAbn: action.data.abn,
        getData: action.data,
        alreadySubmitted: action.data.alreadySubmitted,
        alreadySubmittedDate: action.data.submittedDate,
      };
    }
    case API_INITIATE_POST_AMC_OPTIMIZE_PLAN_DATA:
      return { ...state, optimizeInProgress: true };
    case API_COMPLETE_POST_AMC_OPTIMIZE_PLAN_DATA:
      return { ...state, optimizeInProgress: false, optimizePlanData: action.data, loadedOptimizeData: true };
    default:
      return state;
  }
};

// Map & Connect
export const mapStateToProps = state => ({
  customerAccountNumber: state.amcHomePageReducer.customerAccountNumber,
  customerAccountName: state.amcHomePageReducer.customerAccountName,
  customerAbn: state.amcHomePageReducer.customerAbn,
  authorableContent: state.authorableContentReducer.authorableContent,
  dataLoaded: state.amcHomePageReducer.dataLoaded,
  getData: state.amcHomePageReducer.getData,
  formSubmitted: state.amcHomePageReducer.formSubmitted,
  referenceNumber: state.amcHomePageReducer.referenceNumber,
  alreadySubmitted: state.amcHomePageReducer.alreadySubmitted,
  optimizePlanData: state.amcHomePageReducer.optimizePlanData,
  optimizeInProgress: state.amcHomePageReducer.optimizeInProgress,
  loadedOptimizeData: state.amcHomePageReducer.loadedOptimizeData,
  submissionInProgress: state.amcHomePageReducer.submissionInProgress,
  alreadySubmittedDate: state.amcHomePageReducer.alreadySubmittedDate,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    submitAMCCustomerData,
    submitAMCOptimizePlanData,
    submitAMCRequestCallback,
    downloadCustomerProposal,
  }, dispatch),
});

const AMCHomePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);


export default AMCHomePage;
